__turbopack_context__.v({
  "cItem": "style-module-scss-module__N2TFha__cItem",
  "cItem____noLabel": "style-module-scss-module__N2TFha__cItem____noLabel",
  "cItem__disabled": "style-module-scss-module__N2TFha__cItem__disabled",
  "cItem__fakeIconWrap": "style-module-scss-module__N2TFha__cItem__fakeIconWrap",
  "cItem__readonly": "style-module-scss-module__N2TFha__cItem__readonly",
});
